import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/API/api.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  showError: boolean = false;
  errorMsg = '';
  showSuccess: boolean = false;
  successMsg = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('avatarPreview') avatarPreview!: ElementRef<HTMLImageElement>;
  changePasswordForm: FormGroup

  userData: any;
  profileForm: FormGroup;
  isLoading = false;

  constructor(private api: ApiService, private fb: FormBuilder) {
    this.changePasswordForm = this.fb.group({
      old_password: ['',[Validators.required]],
      new_password: ['',[Validators.required,Validators.minLength(8)]],
      new_password_confirmation: ['',[Validators.required,Validators.minLength(8),this.passwordMatchValidator]],
    })
  }

  passwordMatchValidator(control: any) {
    const password = control?.parent?.get('new_password')?.value;
    const confirmPassword = control?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

  get f() { return this.changePasswordForm.controls; }

  ngOnInit(): void {
    this.initializeForm();
    this.loadProfileData();
  }

  profileImage: any
  loadProfileData() {
    this.isLoading = true;
    this.api.profile().subscribe({
      next: (response) => {
        this.userData = response.data;
        this.profileImage = this.userData.avatar
        // console.log(this.profileImage)
        // Process phone number to remove +2 prefix
        let phoneNumber = this.userData.phone;
        if (phoneNumber && phoneNumber.startsWith('+2')) {
          phoneNumber = phoneNumber.substring(2); // Remove first 2 characters
        }

        this.profileForm.patchValue({
          name: this.userData.name,
          phone: phoneNumber, // Use processed number
          secPhone: this.userData.secPhone || '',
          gender: this.userData.gender
        });
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showError = true
        this.errorMsg = 'حدث خطأ, برجاء المحاولة لاحقا'
        setTimeout(() => {
          this.showError = false
          this.errorMsg = ''
        }, 3000);
      }
    });
  }

  initializeForm() {
    this.profileForm = this.fb.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\+?\d{10,15}$/)]],
      secPhone: ['', Validators.pattern(/^\+?\d{10,15}$/)],
      gender: ['male', Validators.required]
    });
  }

  saveProfile() {
    if (this.profileForm.invalid) {
      this.showError = true;
      this.errorMsg = 'يوجد أخطاء في البيانات المدخلة، يرجى المراجعة';
      setTimeout(() => {
        this.showError = false;
        this.errorMsg = '';
      }, 3000);
      return;
    }

    this.isLoading = true;
    const formData = new FormData();
    
    formData.append('name', this.profileForm.value.name);
    formData.append('phone', this.profileForm.value.phone);
    formData.append('sec_phone', this.profileForm.value.secPhone || '');
    formData.append('gender', this.profileForm.value.gender);
    formData.append('lang', 'ar');

    this.api.updateProfile(formData).subscribe({
      next: (response) => {
        this.showSuccess = true;
        this.successMsg = 'تم تحديث الملف الشخصي بنجاح';
        this.loadProfileData()
        setTimeout(() => {
          this.showSuccess = false;
          this.successMsg = '';
        }, 3000);
        
        this.userData = { 
          ...this.userData,
          name: this.profileForm.value.name,
          phone: this.profileForm.value.phone,
          secPhone: this.profileForm.value.secPhone,
          gender: this.profileForm.value.gender
        };
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.showError = true;
        this.errorMsg = 'فشل في تحديث البيانات، يرجى المحاولة لاحقاً';
        setTimeout(() => {
          this.showError = false;
          this.errorMsg = '';
        }, 3000);
        this.isLoading = false;
      }
    });
  }

  handleImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = './assets/img/default-avatar.jpg';
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      
      // Preview the image immediately
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.avatarPreview.nativeElement.src = e.target.result;
      };
      reader.readAsDataURL(file);

      // Upload the image
      this.uploadImage(file);
    }
  }

  uploadImage(file: File) {
    // console.log(file)
    this.isLoading = true;
    const formData = new FormData();
    formData.append('profileImage', file);

    this.api.updateProfileImage(formData).subscribe({
      next: (response) => {
        this.showSuccess = true;
        this.successMsg = 'تم تحديث الصورة بنجاح';
        this.loadProfileData()
        setTimeout(() => {
          this.showSuccess = false;
          this.successMsg = '';
        }, 3000);
        
        // Update the user data with new image URL
        if (response.data && response.data.avatar) {
          this.userData.avatar = response.data.avatar;
        }
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        this.showError = true;
        this.errorMsg = 'فشل في تحديث الصورة، يرجى المحاولة لاحقاً';
        setTimeout(() => {
          this.showError = false;
          this.errorMsg = '';
        }, 3000);
        this.isLoading = false;
        
        // Revert to previous image on error
        this.avatarPreview.nativeElement.src = this.userData?.avatar || './assets/img/default-avatar.jpg';
      }
    });
  }

  removeProfileImage(){
    this.api.deleteProfileImage().subscribe({
      next: (response) => {
        this.showSuccess = true;
        this.successMsg = 'تم حذف الصورة الشخصية بنجاح';
        this.loadProfileData()
        setTimeout(() => {
          this.showSuccess = false;
          this.successMsg = '';
        }, 3000);
      }, error: (error: HttpErrorResponse) => {
        this.showError = true
        this.errorMsg = 'حدث خطأ, برجاء المحاولة لاحقا'
        setTimeout(() => {
          this.showError = false
          this.errorMsg = ''
        }, 3000);
      }
    })
  }

  removeProfile(){
    this.api.deleteProfile().subscribe({
      next: (response) => {
        this.showSuccess = true;
        this.successMsg = 'تم حذف الملف الشخصي بنجاح';
        setTimeout(() => {
          this.showSuccess = false;
          this.successMsg = '';
          this.api.logout()
          window.location.href = '/'
        }, 3000);
      }, error: (error: HttpErrorResponse) => {
        this.showError = true
        this.errorMsg = 'حدث خطأ, برجاء المحاولة لاحقا'
        setTimeout(() => {
          this.showError = false
          this.errorMsg = ''
        }, 3000);
      }
    })
  }

  changePassword(){
    const formData = new FormData();
    formData.append('old_password', this.changePasswordForm.value.old_password);
    formData.append('new_password', this.changePasswordForm.value.new_password);
    formData.append('new_password_confirmation', this.changePasswordForm.value.new_password_confirmation);

    if(this.changePasswordForm.valid){
      this.api.changePassword(formData).subscribe({
        next: (response) => {
          if(response.success == true){
            this.showSuccess = true;
            this.successMsg = 'تم تغيير كلمة المرور بنجاح';
            setTimeout(() => {
              this.showSuccess = false;
              this.successMsg = '';
              window.location.reload()
            }, 3000);
          }else{
            this.showError = true
            this.errorMsg = 'كلمة المرور القديمة غير صالحة'
            setTimeout(() => {
              this.showError = false
              this.errorMsg = ''
            }, 3000);
          }
        }, error: (error: HttpErrorResponse) => {
          this.showError = true
          this.errorMsg = 'حدث خطأ, برجاء المحاولة لاحقا'
          setTimeout(() => {
            this.showError = false
            this.errorMsg = ''
          }, 3000);
        }
      })
    }
  }

  goBack() {
    history.back();
  }
}